import React, { Component } from 'react';
import { Link } from 'gatsby';
import Step from './Step/index.jsx';
import Button from '../Button/index.jsx';
import styles from './style.module.scss';

import DESIGN_IMG from '../../images/process/design.png';
import SELECT_IMG from '../../images/process/select.png';
import ORDER_IMG from '../../images/process/order.png';
import RECEIVE_IMG from '../../images/process/affinity.png';

const steps = [
	{ 
		title: "Design or provide artwork", 
		content: [ 
			"Send us your custom artwork or use one of our talented designers to come up with a fresh design (for free!)",
		],
		image: DESIGN_IMG,
	},
	{
		title: "Select garments",
		content: [
			"Choose from a variety of garments, including unisex tees, sweats, tanks, and pretty much anything else you can think of!",
		],
		image: SELECT_IMG,
	},
	{
		title: "Online order",
		content: [
			"We build your group a custom store so you can offer your members a seamless ordering experience. Garments are priced based on how many your group orders.",
		],
		image: ORDER_IMG,
	},
	{
		title: "Garments are shipped",
		content: [
			"Most garments can be printed in 10 days or quicker. All of our Greek products are Official Licensed Products.",
		],
		image: RECEIVE_IMG,
	}
]

class CustomizationProcess extends Component {


	render() { 

		const ContactButton = () =>
			<Link to='/new-order'>
				<Button 
					secondary 
					onClick={e => e.preventDefault} 
					children="Get Dressed"/>
			</Link>

		return (
			<div className={styles.container}>
				<h1>How it works</h1>
				<div className={styles.inner}>
					<div className={`${styles.step} ${styles.left}`} id="">
						<Step 
							direction='left'
							title={steps[0].title}
							content={steps[0].content}
							image={steps[0].image}/>
					</div>
					<div className={`${styles.step} ${styles.right}`}>
						<Step 
							direction='right'
							title={steps[1].title}
							content={steps[1].content}
							image={steps[1].image}/>
					</div>
					<div className={`${styles.step} ${styles.left}`}>
						<Step 
							direction='left'	
							title={steps[2].title}
							content={steps[2].content}
							image={steps[2].image}/>
					</div>
					<div className={`${styles.step} ${styles.right}`}>
						<Step 
							direction='right'	
							title={steps[3].title}
							content={steps[3].content}
							image={steps[3].image}/>
					</div>
				</div>
				<ContactButton/>
			</div>
		)
	}
}

export default CustomizationProcess;